import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";

export default function BottomModal({
  open,
  toggleDrawer,
  toggleDrawerShare,
  setShowCheckbox,
  handleSnackbarOpen,
  setShowSimilar,
  setShowCompare,
}) {
  const handleCompare = (e) => {
    setShowCompare(false);
    toggleDrawer(false)(e);
    setShowCheckbox(true);
    handleSnackbarOpen({ target: { checked: true } });
  };

  const handleSimilar = (e) => {
    setShowCompare(false);
    toggleDrawer(false)(e);
    setShowSimilar(true);
  };

  const handleShare = (e) => {
    toggleDrawer(false)(e);
    toggleDrawerShare(true)(e);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          minHeight: "208px",
          borderRadius: "16px 16px 0px 0px",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <CloseIcon
        onClick={toggleDrawer(false)}
        sx={{
          marginTop: "18px",
          marginLeft: "18px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          marginTop: "30px",
          marginBottom: "28px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "24px" }}>
          <Typography
            variant="body1"
            fontWeight="400"
            fontSize="16px"
            lineHeight="24px"
            color="text.primary"
            onClick={handleCompare}
            sx={{
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            Compare this listing
          </Typography>
          <Typography
            variant="body1"
            fontWeight="400"
            fontSize="16px"
            lineHeight="24px"
            color="text.primary"
            onClick={handleSimilar}
            sx={{
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            Find similar listing
          </Typography>
          <Typography
            variant="body1"
            fontWeight="400"
            fontSize="16px"
            lineHeight="24px"
            color="text.primary"
            onClick={handleShare}
            sx={{
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            Share
          </Typography>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}
